var map = {
	"./add-circle.png": 154,
	"./adduser.png": 5569,
	"./alert.png": 4608,
	"./copy.png": 2903,
	"./dashboardic.png": 9886,
	"./document-text.png": 1767,
	"./edit.png": 6960,
	"./integration.png": 6020,
	"./lineBoard.png": 268,
	"./lineopic.png": 9147,
	"./linesetting.png": 7804,
	"./login_bg_1.png": 79,
	"./login_bg_2.png": 5428,
	"./login_bg_3.png": 1725,
	"./logo.png": 317,
	"./logo_blue.png": 7826,
	"./notification-bing.png": 158,
	"./pepsi.png": 1801,
	"./pepsi2.png": 7631,
	"./plantsetting.png": 3681,
	"./profile.png": 3625,
	"./recovery-convert.png": 9967,
	"./refresh.png": 7407,
	"./setting.png": 5690,
	"./sidebaruser.png": 6679,
	"./tasksquare.png": 9634,
	"./tickcircle.png": 3115,
	"./trash.png": 9276,
	"./trenddown.png": 8463,
	"./useraddcircle.png": 9423,
	"./warning.png": 9862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2967;